//

import type {
  BeneficiaryType,
  IGetBeneficiariesResponse,
  IPolicyPolicyData,
} from '@/shared/api/models.bff';

export enum ClientCommunicationsPhone {
  US_EN = '(800) 257-4725',
  CA_EN = '(800) 387-7876',
  CA_FR = '(800) 265-4804',
}

export interface IContactInfo {
  phone?: string;
  email?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zip?: string;
  updateAll?: boolean;
}

export interface IPolicyStoreLoadingBeneficiaries {
  actionStatus: string;
  nameBeneficiary: string;
  relationship: string;
  ssnofBeneficiary: string;
  benefitPercentage: number;
  isBeneficiaryIrrevocable: string;
  beneType: string;
  firstName: string;
  lastName: string;
  middleName: string;
  personType: string;
  trusteeFirstName: string;
  trusteeLastName: string;
  emailAddress: string;
  telephone: string;
  dateofBirth: string;
  address: IPolicyStoreLoadingBeneficiariesAddress;
}

export interface IPolicyStoreLoadingBeneficiariesAddress {
  addressLine1: string;
  addressLine2: string;
  city: string;
  stateCode: string;
  zipCode: string;
  addressCountry: string;
}
export interface IPolicyStoreLoading {
  payment: boolean;
  policy: boolean;
  ach: boolean;
  beneficiaries?: IPolicyStoreLoadingBeneficiaries[];
}

export interface IPolicyStorePaymentPanelItemEditPayments {
  paymentMethodChangeAlert: boolean;
  editPaymentMethod: boolean;
  disablePaymentDetailsLink: boolean;
}

export interface IPolicyStorePaymentPanelItem {
  contractId: number;
  editPayments: IPolicyStorePaymentPanelItemEditPayments;
  panelValue: number;
}

export interface IPolicyStorePoliciesPolicyDataDetailsInsured {
  dateOfBirth: string;
  issueDate: string;
  sex: string;
  issueAge: string;
  planType: string;
  planDescription: string;
  underwritingClass: string;
  benefitAmount: string;
  name: string;
}
export interface IPolicyStorePolicyData {
  owner: {
    name: string;
    phone: string;
    email: string;
    address: {
      line1: string;
      line2: string;
      city: string;
      state: string;
      zip: string;
      phone: string;
    };
  };
  paymentInfo: {
    premium: string;
    paidToDate: string;
    method: string;
    draftDate: string;
  };
  details: {
    primaryInsured: string;
    status: string;
    insured: IPolicyStorePoliciesPolicyDataDetailsInsured[];
    annuity: {
      value: string;
      type: string;
      description: string;
      issueDate: string;
    };
  };
  totalCoverageAmount: number;
  bank: {
    accountNumber: string;
    payorName: string;
    bankName: string;
  };
  isUSPolicy?: boolean;
}

export interface IPolicyStorePolicyPaymentInfo {
  zipCode?: string;
  // PolicyNumber?: string;
  // AccountName?: string;
  // AccountType?: string;
  // RoutingNumber?: string;
  // AccountNumber?: string;
  // ReturnCode?: string;
  // PolicyRecordID?: string;
  // ZipCode?: string;
  // NewPremiumAmount?: string;
  // ModePremiumAmount?: string;
  // PolicyStatus?: string;
  // RestrictCode?: string;
  // SuspendCode?: string;
  // PaidToDate?: string;
  // BillToDate?: string;
  // AutoDraftPaymentDate?: string;
  // BillMode?: string;
  // BillForm?: string;
  // PACPremium?: string;
  // QuarterlyPremium?: string;
  // SemiAnnualPremium?: string;
  // AnnualPremium?: string;
  // PayInProcess?: string;
  // NextCycleDate?: string;
  // MinimumPaymentAmount?: string;
  // TotalPaymentAmount?: string;
  // InSufficientFunds?: boolean;
  // HasAnnuity?: boolean;
  // HasMultipleOptions?: boolean;
  // DisplayAnnuity?: boolean;
  // PastDueAmountPlusPac?: string;
  // PastDueAmount?: string;
  // IsPastDue?: boolean;
  // PastDueDays?: number | null;
  // IsPTDFuture?: boolean;
  // BankName?: string;
  accountName: string;
  accountNumber: string;
  accountType: string;
  autoDraftPaymentDate: string;
  billForm: string;
  billMode: string;
  billToDate: string;
  errorMessage?: string;
  modePremiumAmount: string;
  newPremiumAmount: string;
  nextCycleDate: string;
  paidToDate: string;
  policyNumber: string;
  policyRecordID: string;
  policyStatus: string;
  restrictCode: string;
  returnCode: string;
  routingNumber: string;
  suspendCode: string;
  // zipCode: string;

  bank: {
    account: string; // ? paymentInfo.AccountNumber
    name: string; // ? paymentInfo.BankName
    payorName: string; // ? paymentInfo.AccountName
  };

  minimumPaymentAmount: number;
  annualPremium: number;
  monthlyPremium: number; // ? paymentInformation.PACPremium
  quarterlyPremium: number;
  semiAnnualPremium: number;
  totalPaymentAmount: number;

  isSavingsAccount: boolean; // ? paymentInfo.AccountType === '3',
  payInProcess: boolean; // ? paymentInfo.PayInProcess === '1'
  // _nextCycleDate?: string; // TODO: verify if needed
  // _accountNumber?: string; // TODO: verify if needed
  // _payInProcess?: string; // TODO: verify
  // _billToDate?: string;
}

export interface IPolicyStorePolicyServicingAgent {
  id: string;
  cellPhone: string;
  firstName: string;
  lastName: string;
  email: string;
  name: string;
  title: string;
  titleDescription: string;
  office: string;
  phone?: string;
  homeOffice: boolean;
  lifeLicensed: boolean; // 'N' or 'Y'
  displayPic: string;
  securitiesLicensed: boolean; // 'N' or 'Y'
  isRvp: boolean;
  licensedProducts: string[];
}

export interface IPolicyStorePolicyPhases {
  // phPlanzPerson: string;
  // phIssueDate: string;
  // phIssueState: string;
  // phaseSequenceNo: string;
  // personFirstName: string;
  // personLastName: string;
  // personSex: string;
  // personDateOfBirth: string;
  // personIssueAge: string;
  // phaseIsIBR: boolean;
  // phaseIsAnnuity: boolean;
  // planzText: string;
  // phaseEOTDate: string;
  // phInforceCode: string;
  // phPremium: string;
  // phWPPrem: string;
  // phWPPremSpouse: string;
  // phUndwPremClass: string;
  // phValuePerUnit: string;
  // phUnits: string;

  // New starts here
  coverageAmount: number;
  inForceCode: string;
  isIbr: boolean;
  isAnnuity?: boolean;
  issueAge: number;
  issueDate: Date | null;
  issueState: string;
  dateOfBirth: Date | null;
  eotDate: Date | null;
  premium: number;
  insuredName: string;
  isChild: boolean;
  person: string;
  planDescription: string;
  planDescriptionFrench: string;
  planText: string;
  sequenceNumber: string;
  sex: string;
  underwritingClass: string;
  wpPrem: number;
  wpPremSpouse: number;
  phaseNo?: string;
  personTaxId?: string;
  phPlan?: string;
  phOtherPrem?: string;
}

export interface IPolicyStorePolicyOwner {
  firstName?: string; // TODO: verify
  lastName?: string; // TODO: verify
  name: string;
  dob: null | string;
  ssn: string;
  email: string;
  address: {
    phone: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    _zip?: string;
  };
}

export interface IPolicyStorePolicyPayNowInfo {
  // TODO: verify if needed
  totalPaymentAmount: number;
  minimumPaymentAmount: number;
  inSufficientFunds: boolean;
  hasAnnuity: boolean;
  hasMultipleOptions: boolean;
  isPastDue: boolean;
  isPTDFuture: boolean;
  pastDueAmount: string;
  pastDueAmountPlusPac: string;
  pastDueDays: number;
}

export interface IPolicyStorePolicyReinstatement {
  paymentAsOfReIssueDate: number;
  paymentAsOfOrgIssueDate: number;
  termDate: string;
  pacPremium: string;
  eligible: boolean;
  eligibleDod?: boolean;
  // Below here are things that I dont see mapped for Reinstatement but are backend.
  placeHolderId?: string;
  state?: string;
  redirectUrl?: string;
}

export interface IPolicyStorePolicyBeneficiaries {
  personCode: string;
  effectiveDate: string;
  relation: string;
  ssn: string;
  name: string;
  firstName: string;
  lastName: string;
}

export interface IPolicyStorePolicyPayments {
  date: string | null;
  amount: string;
}

export interface IPolicyStorePolicy {
  // t
  contractId: string;
  payNowLinkDesc: string;
  agentId: string;
  policyStatusDesc?: string; // TODO: verify if needed
  showPayNowLink: boolean;
  showAddChildLink: boolean; // TODO: verify if needed

  data?: IPolicyPolicyData;
  activePrimaryCoverage: number;
  activeSpouseCoverage: number;
  annuityCoverage?: number;
  annuityAmount?: number;
  childCoverage?: number; // TODO: verify if needed
  primaryCoverage?: number; // TODO: verify if needed
  spouseCoverage?: number; // TODO: verify if needed
  totalCoverage?: number; // TODO: verify if needed
  restricted?: boolean;
  canUpdateAll?: boolean;
  canUpdateContactInfo?: boolean;
  canPrintDocuments?: boolean;
  canMakeOneTimePayment?: boolean;
  canUpdatePaymentInfo?: boolean;
  status: string;
  statusText: string;
  active?: boolean;
  pending?: boolean;
  terminated?: boolean;
  billingForm?: string;
  billingMode?: string;
  modePremium?: number;
  nextDraftDate?: string;
  issueDate?: Date | null;
  billToDate?: Date | null;
  recordId?: string;
  recordStatus?: string;
  restrictCode?: string;
  state?: string;
  policyNumber?: string;
  primaryInsuredIsOwner?: boolean;
  clientEmail?: string;
  wipRecordExists?: boolean;
  bankName?: string;
  paidToDate?: Date | null;
  nextPaymentDueDate?: Date | null;
  rvpName?: string;
  isRvpRvp?: boolean;
  rvpTitleDesc?: string;
  isA1BillingForm?: boolean;
  isB2BillingForm?: boolean;
  writingAgent?: {
    id?: string;
    name?: string;
    status?: string;
  };
  writingAgent2?: {
    id?: string;
    name?: string;
    status?: string;
  };

  isCanadianQuebecBeneficiaryPolicy?: boolean;
  isCanadianPolicy?: boolean;
  showOneTimePayment?: boolean; // TODO: verify if needed

  policyData: IPolicyStorePolicyData;
  paymentInfo?: IPolicyStorePolicyPaymentInfo;
  HasMultipleOptions?: number;
  paynowInfo: IPolicyStorePolicyPayNowInfo;

  kubraPaymentStatus?: boolean | null; // TODO: verify if needed
  details?: never;

  nextGenPolicy?: boolean;

  // a
  servicingAgent?: IPolicyStorePolicyServicingAgent;
  servicingRVP?: IPolicyStorePolicyServicingAgent;

  // p
  payments?: IPolicyStorePolicyPayments[];
  beneficiaries?: IPolicyStorePolicyBeneficiaries[];

  phases?: IPolicyStorePolicyPhases[] | [];
  annuity?: IPolicyStorePolicyPhases[] | []; // Based on line # 40 of Policy.ts
  childRider?: IPolicyStorePolicyPhases[] | [];
  owner?: IPolicyStorePolicyOwner;

  // n
  insuredName?: string; // TODO: verify if needed
  primaryInsured?: {
    firstName: string;
    lastName: string;
  };
  // This doesn't exist instead we are using spouseFirstName and spouseLastName to check for spouse being insured
  // spouseInsured?: string;

  // r
  reinstatement?: IPolicyStorePolicyReinstatement; // TODO: verify if needed

  // d
  isCanadaQuebecPolicy?: boolean;
  isCanadaQuebecBeneficiaryPolicy?: boolean;
  isCanadaPolicy?: boolean;
  allowEditBeneficiary?: boolean;
  dateFormat?: string;
  isNewYorkPolicy?: boolean;
  isUSPolicy?: boolean;
  country?: string;
}

export interface IPolicyStorePaymentData {
  amount: string;
  paymentType: string;
  accountType: string;
  accountCode: string;
  accountHolder: string;
  routingNumber: string;
  accountNumber: string;
  bankName: string;
}

export interface IPolicyStoreBeneficiaryInfo {
  beneficiaryType: BeneficiaryType;
  origin?: string;
  irrevocable: boolean;
  fullName?: string;
  beneficiaryPercent?: number | string;
  dateSigned?: string;
}

export interface IPolicyStore {
  step: number;
  loading: IPolicyStoreLoading;
  navHintDismissed: boolean;
  selectedPolicyIndex: number;
  paymentPanel: IPolicyStorePaymentPanelItem[];
  policies: IPolicyStorePolicy[];
  successResponseUpdateContactInfo: never[];
  errorResponseUpdateContactInfo?: string[];
  addressVerification?: IContactInfo | string;
  addressUpdateSuccess: boolean;
  base64String: BlobPart | null;
  contactDetailsPanel: number;
  editContactInfo: boolean;
  bankName: string | null;
  paymentData: IPolicyStorePaymentData;
  restrictedPolicy: boolean;
  showPayNowInfoCard: boolean;
  paymentInfoShowPaymentAmountDateBillingMethod: boolean;
  payNowLinkToggle: boolean;
  updatingBank: boolean;
  preLoadBank: boolean | null;
  beneficiaries: IPolicyStoreBeneficiaryInfo[];
  beneficiaryStep: number;
  beneficiaryPrimary: IGetBeneficiariesResponse[];
  beneficiaryPrimaryContingent: IGetBeneficiariesResponse[];
  beneficiarySpouse: IGetBeneficiariesResponse[];
  beneficiarySpouseContingent: IGetBeneficiariesResponse[];
  isBeneficiaryDataDirty: boolean;
  paymentStep: number;
  routeNameToNavigateBack: string;
  hasTerminatedPolicies?: boolean;
  terminatedPolicyAgent?: null;
  scrollToPolicyDetails: string; // 'policy-panel',
  withDrawalDateStep: number;
  changeBankAccountStep: number;
  payMethodChange: number;
  customerProfile?: never;
  preferences?: {
    navHint: never;
  };
}
export interface IPolicyStoreGetters {
  hasTermLife: (state: IPolicyStore) => never;
  currentPolicy: (state: IPolicyStore) => never;
  currentPaymentPanel: (state: IPolicyStore) => never;
  issueDateForCurrentPolicy: (state: IPolicyStore) => never;
  panelValue: (state: IPolicyStore) => never;
  policyOwner: (state: IPolicyStore) => never;
  activePrimaryCoverage: (state: IPolicyStore) => never;
  activeSpouseCoverage: (state: IPolicyStore) => never;
  isPending: (state: IPolicyStore) => never;
  isRestricted: (state: IPolicyStore) => never;
  isHomeOffice: (state: IPolicyStore) => never;
  restrictCodeMessage: (state: IPolicyStore) => never;
  clientCommunicationsPhone: (state: IPolicyStore) => never;
  policyCount: (state: IPolicyStore) => never;
  bankNameResponse: (state: IPolicyStore) => never;
  paymentInfoLoading: (state: IPolicyStore) => never;
  achSubmissionLoading: (state: IPolicyStore) => never;
  policyInfoLoading: (state: IPolicyStore) => never;
  beneficiariesLoading: (state: IPolicyStore) => never;
  getPaymentMethodChangeAlert: (state: IPolicyStore) => never;
  getEditPaymentMethod: (state: IPolicyStore) => never;
  getDisablePaymentDetailsLink: (state: IPolicyStore) => never;
  showPayNow: (state: IPolicyStore) => never;
  showPayNowFeatureFlagAndPayNowLinkToggle: (state: IPolicyStore) => never;
  policiesSortedByDate: (state: IPolicyStore) => never;
  beneficiariesTotalPrimaryPrimary: (state: IPolicyStore) => never;
  beneficiariesTotalPrimaryContingent: (state: IPolicyStore) => never;
  beneficiariesTotalSpousePrimary: (state: IPolicyStore) => never;
  beneficiariesTotalSpouseContingent: (state: IPolicyStore) => never;
  showSpouseSection: (state: IPolicyStore) => never;
  fetchDataForVAndTPrimaryPrimary: (state: IPolicyStore) => never;
  fetchDataForVAndTPrimaryContingent: (state: IPolicyStore) => never;
  fetchDataForVAndTSpousePrimary: (state: IPolicyStore) => never;
  fetchDataForVAndTSpouseContingent: (state: IPolicyStore) => never;
  beneficiaryHasOriginVorTWithIrrevocable: (state: IPolicyStore) => never;
  beneficiaryHasOriginVorT: (state: IPolicyStore) => never;
}

export interface IPolicyStorePaymentInfoWBankAccount {
  bankAccount?: {
    accountName: string;
    accountNumber: string;
    accountType: string;
    routingNumber: string;
  };
  draftAmount: string;
  draftDay: string;
  emailAddress: string;
  language: string;
  nextCycleDate: string;
  reqMode: string;
  type: string;
}

export interface IPolicyStoreBankInfo {
  paymentInfo: IPolicyStorePaymentInfoWBankAccount;
  policyNumber: string;
}

export interface IPolicyBankInfo {
  accountName: string;
  accountNumber: string;
  accountType: string;
  accountTypeString: string;
  bankName: string;
  draftAmount: string;
  draftDay: string;
  isCanada: boolean;
  nextCycleDate: string;
  nextDraftDate: string;
  policyNumber: string;
  reqMode: string;
  routingNumber: string;
}
